/**
 * 2022-2024 Stadt Wolfsburg
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react';
import {connect} from 'react-redux';

import PropTypes from 'prop-types';
import ConfigUtils from 'qwc2/utils/ConfigUtils';
import LocaleUtils from 'qwc2/utils/LocaleUtils';

import './style/AppMenuLabel.css';

class WobAppMenuLabel extends React.Component {
    static propTypes = {
        currentTheme: PropTypes.object
    };
    static defaultProps = {
    };
    render() {
        const themeTitle = this.props.currentTheme ? this.props.currentTheme.title : "";
        const username = ConfigUtils.getConfigProp("username");
        if (themeTitle || username) {
            return (
                <span className="appmenu-label">
                    <span className="wob-appmenu-label-container">
                        <span>{LocaleUtils.tr("appmenu.menulabel")}</span>
                        <span className="wob-appmenu-sublabel">
                            {themeTitle ? (
                                <span className="wob-appmenu-sublabel-themetitle"
                                    style={username ? {maxWidth: 'calc(' + 60 + '% - 0.5em)'} : {maxWidth: 100 + '%'}}
                                    title={themeTitle}>
                                    {themeTitle}
                                </span>
                            ) : null}
                            {themeTitle && username ? (
                                <span className="wob-appmenu-sublabel-separator"
                                    dangerouslySetInnerHTML={{__html: "&nbsp;|&nbsp;"}}
                                    style={{maxWidth: '1em'}} />
                            ) : null}
                            {username ? (
                                <span className="wob-appmenu-sublabel-username"
                                    style={themeTitle ? {maxWidth: 'calc(' + 40 + '% - 0.5em)'} : {maxWidth: 100 + '%'}}
                                    title={username}>
                                    {username}
                                </span>
                            ) : null}
                        </span>
                    </span>
                </span>
            );
        } else {
            return (<span className="appmenu-label">{LocaleUtils.tr("appmenu.menulabel")}</span>);
        }
    }
}

const selector = (state) => ({
    currentTheme: state.theme.current || {}
});

export default connect(selector, {
})(WobAppMenuLabel);
